import { http } from './http';
import { baseURL, huntEndpoint } from './wpConfig';
import {
    HuntLeaderboardResponse,
    HuntMeResponse,
    HuntSubmitPayload,
    HuntSubmitScoreResponse,
} from './types';
import { UserCredentials } from './wpAuth';

export const submitScore = (
    userCredentials: UserCredentials,
    payload: HuntSubmitPayload
): Promise<HuntSubmitScoreResponse> => {
    const endPoint = `${baseURL}${huntEndpoint}/score`;
    return http.post<HuntSubmitScoreResponse>(endPoint, payload, { auth: userCredentials });
};

export const getLeaderboard = (
    period: 'day' | 'week',
    limit = 20
): Promise<HuntLeaderboardResponse> => {
    const endPoint = `${baseURL}${huntEndpoint}/leaderboard?period=${period}&limit=${limit}`;
    return http.get<HuntLeaderboardResponse>(endPoint);
};

export const getHuntMe = (userCredentials: UserCredentials): Promise<HuntMeResponse> => {
    const endPoint = `${baseURL}${huntEndpoint}/me`;
    return http.get<HuntMeResponse>(endPoint, { auth: userCredentials });
};
